import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Paper } from "@mui/material";
import api from "../components/setupAxios"; 
import API_URL from "../config"; 

const StudentDetails = () => {
  const { studentId } = useParams(); 
  const [student, setStudent] = useState(null); 
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    fetchStudentInfo();
    fetchStudentLogs();
  }, [studentId]);

  const fetchStudentInfo = async () => {
    try {
      const res = await api.get(`/auth/users/${studentId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });
      setStudent(res.data);
    } catch (error) {
      console.error("Error fetching student info:", error);
    }
  };

  const fetchStudentLogs = async () => {
    try {
      const res = await api.get(`/student-log/student/${studentId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });
      setLogs(res.data);
    } catch (error) {
      console.error("Error fetching student logs:", error);
    }
  };

  const computeTotalDuration = () => {
    let totalMs = 0;
    logs.forEach(log => {
      if (log.timeOut) {
        totalMs += new Date(log.timeOut) - new Date(log.timeIn);
      }
    });
    const totalSeconds = Math.floor(totalMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours}h ${minutes}m ${seconds}s`;
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Student Details
      </Typography>

      {student ? (
        <Box sx={{ mb: 2 }}>
          <Typography><strong>User ID:</strong> {student.userId}</Typography>
          <Typography><strong>Name:</strong> {student.firstName} {student.lastName}</Typography>
        </Box>
      ) : (
        <Typography>Loading student info...</Typography>
      )}

      <Typography variant="h6" gutterBottom>
        Logs
      </Typography>

      {logs.length === 0 ? (
        <Typography>No logs found for this student.</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Time In</TableCell>
                <TableCell>Time Out</TableCell>
                <TableCell>Borrowed Item</TableCell>
                <TableCell>Lab Location</TableCell>
                <TableCell>Seats</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map((log) => (
                <TableRow key={log._id}>
                  <TableCell>{new Date(log.timeIn).toLocaleString()}</TableCell>
                  <TableCell>
                    {log.timeOut
                      ? new Date(log.timeOut).toLocaleString()
                      : "Still in session"}
                  </TableCell>
                  <TableCell>{log.borrowedItem || "N/A"}</TableCell>
                  <TableCell>{log.labLocation || "Unknown"}</TableCell>
                  <TableCell>
                    {Array.isArray(log.seats)
                      ? log.seats.map((s) => `${s.podId}-${s.seatId}`).join(", ")
                      : "N/A"}
                  </TableCell>
                </TableRow>
              ))}

              <TableRow>
                <TableCell colSpan={5} align="right">
                  <strong>Total Duration: {computeTotalDuration()}</strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default StudentDetails;
